import React, { type ReactNode } from "react";
import { View } from "react-native";
import { semanticColors } from "@louise/moon-ui/theme/tokens";
import { Text } from "@src/packages/medical-history/components/MedicalHistoryText";
import { cardSurface } from "@louise/moon-ui";

export type FertilityTreatmentCycleCardProps = {
  cycleLabel: string;
  children: ReactNode;
  testID?: string;
};

/** Shared glass container for repeated fertility-treatment details. */
export function FertilityTreatmentCycleCard({
  cycleLabel,
  children,
  testID,
}: FertilityTreatmentCycleCardProps) {
  return (
    <View
      testID={testID}
      style={[
        cardSurface(),
        {
          width: "100%",
          padding: 16,
          gap: 12,
        },
      ]}
    >
      <Text
        variant="title"
        size="sm"
        className="font-dm-sans-medium"
        style={{
          color: semanticColors.text.primary,
          fontSize: 15,
          lineHeight: 20,
        }}
      >
        {cycleLabel}
      </Text>
      {children}
    </View>
  );
}
